import React, { useMemo } from 'react';
import CampoComboPais from '../UI/campos/CampoComboPais.js';
import CampoEditableTexto from '../UI/campos/CampoEditableTexto.js';
import CampoEditableFechaCampos from '../UI/campos/CampoEditableFechaCampos.js';
import CampoOptionsSexo, { Sexo } from '../UI/campos/CampoOptionsSexo.js';
import AgregarItemFiltro from '../UI/AgregarItemFiltro.js';
import * as Data from '../data/DataPersonas.js';

const NuevaPersonaFiltro = (props) => {
  const onMostrarLista = props.onMostrarLista;
  const autoAbrir = props.autoAbrir ?? false;

  // Configuración de campos
  const campos = useMemo(
    () => [
      {
        nombre: 'apellido',
        titulo: 'Apellido',
        componente: <CampoEditableTexto />,
        valorInicial: '',
      },
      {
        nombre: 'nombre',
        titulo: 'Nombre',
        componente: <CampoEditableTexto />,
        valorInicial: '',
      },
      {
        nombre: 'sexo',
        titulo: 'Sexo',
        componente: <CampoOptionsSexo />,
        valorInicial: Sexo.MASCULINO,
      },
      {
        nombre: 'pais',
        titulo: 'País Nacimiento',
        componente: <CampoComboPais incluirNulo={true} />,
        valorInicial: null,
      },
      {
        nombre: 'fecNac',
        titulo: 'Fecha Nacimiento',
        componente: <CampoEditableFechaCampos anio={null} mes={null} dia={null} />,
        valorInicial: null,
      },
    ],
    []
  );

  // Validar filtros
  const validarFiltros = (filtros) => {
    if (!filtros.apellido || filtros.apellido.trim() === '') {
      return {
        valido: false,
        error: 'Debe ingresar el apellido de la persona',
      };
    }
    return { valido: true };
  };

  // Normalizar filtros
  const normalizarFiltros = (filtros) => {
    // Si fecNac tiene estructura especial, descomponer
    // sino devolver igual
    return filtros;
  };

  // Extraer nombre para búsqueda
  const extraerNombre = (filtros) => {
    return filtros.apellido || '';
  };

  // Buscar personas existentes
  const onBuscar = async (filtros) => {
    return await Data.SearchPersonasNueva(filtros);
  };

  // Crear nueva persona
  const onCrear = async (filtros) => {
    return await Data.PostNuevaPersona(filtros);
  };

  return (
    <AgregarItemFiltro
      objeto="persona"
      campos={campos}
      onBuscar={onBuscar}
      onCrear={onCrear}
      onMostrarLista={onMostrarLista}
      validarFiltros={validarFiltros}
      normalizarFiltros={normalizarFiltros}
      extraerNombre={extraerNombre}
      autoAbrir={autoAbrir}
      ocultarBotonAgregar={autoAbrir}
      rutaDestino="/persona/"
    />
  );
};

export default NuevaPersonaFiltro;
